<template>
  <div class="px-0">
    <div
      class="relative py-[23%] disableClippedBg -mb-3"
      :class="{ 'mb-12!': !loading && (loadingError || !coupons?.length) }"
    >
      <!-- Empty / Error State -->
      <SectionEmptyState
        v-if="!loading && (loadingError || !coupons?.length)"
        class="absolute top-0 left-0 w-full h-full pb-[15%]"
        title="De bonnes réductions vous attendent ici"
        description="Revenez bientôt pour profiter de réductions exclusives !"
        icon-type="coupons"
        @refresh="refreshCoupons"
      />

      <!-- Loading State (Shimmer) -->
      <div
        v-else-if="loading"
        class="absolute top-0 left-0 w-full overflow-auto flex justify-center"
      >
        <div class="flex w-max gap-6 mt-2">
          <div class="w-[80vw]">
            <div class="shimmerElement py-[26%]"></div>
          </div>
          <div class="w-[80vw]">
            <div class="shimmerElement py-[26%]"></div>
          </div>
          <div class="w-[80vw]">
            <div class="shimmerElement py-[26%]"></div>
          </div>
        </div>
      </div>

      <!-- SwipperView Carousel -->
      <div v-else class="w-full h-full absolute left-0 top-0">
        <SwipperView
          :slidesPerView="1.2"
          :nbTabs="coupons.length"
          :centeredSlides="true"
          :autoPlay="8105"
          :loop="true"
          :defaultTab="1"
          class="h-full"
        >
          <template #default="{ position }">
            <div class="w-full relative p-2 -mb-12">
              <div class="w-full left-0 top-0">
                <CouponItem small :item="currentCoupon(position)" />
              </div>
            </div>
          </template>
        </SwipperView>
      </div>
    </div>
    <div class="py-2"></div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import { bus } from '@core/events/eventSystem';
import { getStore } from '@core/store';
import constants from '@core/utils/constants';

const homeStore = getStore('home');

const couponsColors = ['#FF7200', 'red', '#00BE6F', 'green'];
const templateKeys = [1, 2];

const templateImages = [
  '/images/coupons/giftWhite.png',
  '/images/coupons/giftBlack.png',
  '/images/coupons/giftBlue.png'
];

// Computed properties for store state
const coupons = computed(() => {
  const items = homeStore.state.coupons?.items || [];
  const now = Date.now();
  const validCoupons = items.filter((c) => {
    if (c.active === false) return false;
    if (c.validTo && new Date(c.validTo).getTime() < now) return false;
    return true;
  });
  // Limit to 3 latest coupons
  return validCoupons.slice(0, 3);
});
const loading = computed(() => homeStore.state.coupons?.loading || false);
const loadingError = computed(() => homeStore.state.coupons?.error || null);

// Get current coupon for display based on position
function currentCoupon(position) {
  if (coupons.value.length === 0) return {};
  const coupon = coupons.value[Math.abs(position) % coupons.value.length];
  return {
    ...coupon,
    color:
      coupon.color || couponsColors[Math.abs(position) % couponsColors.length],
    templateKey:
      coupon.templateKey ||
      templateKeys[Math.abs(position) % templateKeys.length],
    image:
      coupon.templateImage ||
      templateImages[Math.abs(position) % templateImages.length]
  };
}

function refreshCoupons() {
  bus.emit(constants.EVENTS.HOME.COUPONS_LOAD);
}

onMounted(() => {
  // Load coupons when component mounts
  bus.emit(constants.EVENTS.HOME.COUPONS_LOAD);
});
</script>

<style scoped>
.pubsContainerCliped {
  clip-path: polygon(0% 0%, 100% 0%, 100% 85%, 0% 100%);
}
.disableClippedBg .pubsContainerCliped {
  clip-path: none;
}

/* Shimmer animation */
@keyframes shimmer {
  0% {
    background-position: -1000px 0;
  }
  100% {
    background-position: 1000px 0;
  }
}

.shimmerElement {
  background: linear-gradient(
    to right,
    #f6f7f8 0%,
    #edeef1 20%,
    #f6f7f8 40%,
    #f6f7f8 100%
  );
  background-size: 1000px 100%;
  animation: shimmer 2s infinite linear;
}
</style>
